import swal from 'sweetalert';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react'; 

/* USE THIS FUNCTION WHEN YOU WANT TO SHOW SWAL ALERT MESSAGE BASED ON STATUS CODE FROM RESPONSE */
export const getStatusAlert = ({status, message, reCallGrid, buttonText,hide}) => {
    switch (status) {
        case 1:
            swal(message, { icon: "success"})
            if (reCallGrid !== undefined) {
                reCallGrid();
            }
            if(hide !== undefined){
                hide();
            }
            break;
        case 3:
            return swal(message, { icon: "warning", button: "Ok" }).then(() => {
                if (reCallGrid !== undefined) {
                    reCallGrid();
                }
            })
        case 0:
        case 202:
        case 204:
        case 409:
            return swal(message, { icon: "warning" });
        default:
            return swal({title: message, icon: "error", button: buttonText})
    }
};

export const handleNetworkErrors = (response, setHasError) => {
    try {
        if (response.status !== 200) {
            throw new Error('Network response not OK');
        }
    } catch (e) {
        setHasError({
            error: true,
            message: e
        })
    }
}

const getTotalCount = (column, records, setTotalQuanties) => {
    const totalObj = {}
    const totalQty = records.reduce((acc, currentItem) => acc + Number(currentItem[`${column.dataField}`]), 0);
    totalObj["name"] = column.text.toUpperCase();
    totalObj["count"] = totalQty
    setTotalQuanties((prevState => {
        if(prevState?.length >= 1){
            for(let state of prevState){
                if(state.name === totalObj.name){
                    break;
                }else{
                    return [...prevState, totalObj]
                }
            }
        }
        return [totalObj]
    }))
}
  
export const getReportTotalQuanties = (columns, records,setTotalQuanties) => {
    if(records?.length === 0){
        setTotalQuanties([]);
    }
    else if (records?.length > 0) {
        columns.forEach(column => {
            if (column?.gridTotal) {
                getTotalCount(column, records,setTotalQuanties)
            }
        })
    }
}

const resizeColumns = (columnName) => {
    switch(columnName){
        case 'rowSelect':
            return 50;
        case 'name':
        case 'type_name':
            return 70
        default:
            return 400
    }
}

export const transformColumns = (columns, isRowSelection) => {
    const rowSelectionHeader = {
        dataField: "rowSelect",
        text: "",
    };
    let modifiedColumns = [...columns]
    if(isRowSelection){
        modifiedColumns = [rowSelectionHeader, ...modifiedColumns];
    };

    const totalColumns = modifiedColumns.length;

    const isLastColumnActions = (col) => {
        const text = col.dataField;
        return text === 'actions' || text === 'action';
      };


    const getColumnWidthConfig = (key = '', label = '') => {
        key = key.toLowerCase();
        label = label.toLowerCase();
        console.log("@label", label)
    
        if (label.includes("email")) return { size: 350, minSize: 200, maxSize: 400 };
        if (label.includes("url") || label.includes("link") || label.includes("website"))
          return { size: 500, minSize: 300, maxSize: 600 };
        if (label.includes("product name") ||  label.includes("path") || label.includes("message"))
            return { size: 400, minSize: 300, maxSize: 500 };
        if (
          label.includes("date") ||
          label.includes("timestamp") ||
          label.includes("created_date") ||
          label.includes("updated")
        )
          return { size: 250, minSize: 150, maxSize: 250 };
    
        return { size: 200, minSize: 100, maxSize: 400 }; 
      };

    return modifiedColumns.map((column, index) => {
        const isActions = isLastColumnActions(column);
        const isSecondLast = index === totalColumns - 2;
        const isLastColumn = index === totalColumns - 1
        const isFirst = index === 0;
        const isRowSelect = column.dataField === 'rowSelect';
        // column.text?.toLowerCase() === "actions" || column.text?.toLowerCase() === "action";
        let widthConfig =  getColumnWidthConfig(column.dataField, column.text);

        if (totalColumns < 3 && isFirst) {
            widthConfig = { size: 999, minSize: 300, maxSize: 9999 };
          }
      
          // Case: Less than 4 columns and last column is Actions
          if (totalColumns < 4 && isSecondLast) {
            widthConfig = { size: 500, minSize: 300, maxSize: 700 };
          }
          if(isRowSelect){
            widthConfig = { size: 40, minSize: 20, maxSize: 40 };
            // widthConfig = { size: 480, minSize: 100, maxSize: 480 };
          }

          if (isActions) {
            widthConfig = { size: 150, minSize: 100, maxSize: 200 };
          }

       return {
        accessorKey: column.dataField,
        header: column.text,
        enableSorting: !["rowselect", "actions", "action"].includes(
            column.dataField?.toLowerCase()
          ),
        enableResizing :  !(isActions || isLastColumn),
        enableColumnFilter: !isActions,
        enableColumnMenu: !isActions,
        ...widthConfig,
            muiTableHeadCellProps: {
                sx: {
                fontSize: "1.4rem",
                fontFamily: "Poppins, sans-serif",
                whiteSpace: "nowrap",
                overflowX: 'hidden',
                justifyContent: "space-between",
                textOverflow: 'ellipsis',
                textAlign: "center",
                '& .Mui-TableHeadCell-ResizeHandle-Wrapper': {
                    order: 1,
                    width:'6px',
                    backgroundColor: '#fff',
                    opacity:1,
                },
                },
            },
          muiTableBodyCellProps: {
            sx: {
              fontSize: "1.3rem",
              whiteSpace: "normal",
              wordBreak: 'break-word',
              overflow: "break-word",
            //   LineHeigh: 1.5
            },
          },
        // grow: true,
        Cell: ({ cell }) => (
            <Typography  sx={{ fontSize: '1.4rem', fontFamily: "Poppins"}}>
                {column.text !== 'Actions' ? 
                <Tooltip title={cell.getValue()}>
                    {cell.getValue()}
                </Tooltip> :
                 <>{cell.getValue()}</>
                 }
            </Typography>
            ),
        };
    });
};


export const vibrantUniqueColors = [
    "#1f77b4", "#2ca02c", "#ff7f0e", "#9467bd", "#8c564b",
    "#17becf", "#bcbd22", "#7f7f7f", "#aec7e8", "#98df8a",
    "#ffbb78", "#c5b0d5", "#c49c94", "#9edae5", "#dbdb8d",
    "#393b79", "#637939", "#8c6d31", "#843c39", "#7b4173",
    "#3182bd", "#31a354", "#d6616b", "#6baed6", "#74c476",
    "#e7969c", "#9ecae1", "#a1d99b", "#ad494a", "#756bb1",
    "#6b6ecf", "#e7ba52", "#bd9e39", "#17a768", "#1c9099",
    "#fdd0a2", "#d95f0e", "#d0743c", "#8dd3c7", "#fb8072",
    "#80b1d3", "#b3de69", "#fccde5", "#bc80bd", "#ccebc5",
    "#ffed6f", "#6a3d9a", "#b15928", "#ff9896", "#c7e9c0"
  ];




